'use strict';
import { isNeString } from '@aretheyhappy/utils';
class WindowUtils {
    /**
     * Return either false or a high precision timestamp
     */
    static get now() {
        if (window.performance && typeof window.performance.now === 'function')
            return window.performance.now();
        return false;
    }
    /**
     * Get the origin of the current window
     */
    static get origin() {
        if (window.location.origin)
            return window.location.origin;
        let w_origin = `${window.location.protocol}//${window.location.hostname}`;
        if (window.location.port)
            w_origin = `${w_origin}:${window.location.port}`;
        return w_origin;
    }
    /**
     * Get path of the window
     */
    static get path() {
        return window.location.pathname;
    }
    /**
     * Point the browser at a url inside of our tld
     * @param url
     * @param options
     * @param blank
     */
    static go(url = '', options = { qstring: '', hash: '' }, blank = false) {
        let { qstring = '', hash = '' } = options;
        //  Make sure qstring is prepended with '?' if available
        qstring = isNeString(qstring) ? `?${qstring}` : '';
        //  Add service identifier
        if (localStorage.getItem('__ath_i_sid')) {
            const sid = `__ath_i_sid=${localStorage.getItem('__ath_i_sid')}`;
            qstring = isNeString(qstring) ? `${qstring}&${sid}` : `?${sid}`;
        }
        //  Make sure hash is prepended with '#' if available
        hash = isNeString(hash) ? `#${hash}` : '';
        //  Make sure url is a string
        url = url || '';
        if (blank) {
            window.open(`${WindowUtils.origin}${url}${qstring}${hash}`, '_blank');
        }
        else {
            window.location.href = `${WindowUtils.origin}${url}${qstring}${hash}`;
        }
    }
    /**
     * Open a url outside of our tld
     * @param url
     * @param blank
     */
    static open(url, blank = true) {
        const node = document.createElement('a');
        node.setAttribute('href', url);
        node.setAttribute('target', blank ? '_blank' : '_self');
        document.body.appendChild(node);
        node.click();
    }
    /**
     * Point the browser at the current url inside of our tld
     * @param options
     */
    static refresh(options = { hash: '' }) {
        //  If a hash was passed set one
        if (isNeString(options.hash))
            WindowUtils.hash = options.hash;
        //  Reload window
        window.location.reload();
    }
    /**
     * Get hash of the window
     */
    static get hash() {
        // length > 2 because the # character is counted as well
        if (window.location.hash.length > 2)
            return window.location.hash.substring(1);
        return false;
    }
    /**
     * Set hash on the window
     */
    static set hash(val) {
        if (val === false) {
            const { pathname, search } = window.location;
            history.pushState('', document.title, `${pathname}${search}`);
        }
        else {
            window.location.hash = val;
        }
    }
    ;
    /**
     * Get a specific query parameter
     * @param key
     * @param url
     * @returns
     */
    static query(key, url = false) {
        url = url ? url : window.location.href;
        const regex = new RegExp(`[?&]${key}(=([^&#]*)|&|#|$)`);
        const results = regex.exec(url);
        if (!results)
            return false;
        if (!results[2])
            return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    static hasCookie(key) {
        return document.cookie.match(new RegExp(`^(.*;)?\\s*${key}\\s*=\\s*[^;]+(.*)?$`));
    }
    //  Get a computed style
    static style(key) {
        return window.getComputedStyle(document.documentElement).getPropertyValue(key).trim();
    }
}
export { WindowUtils };
export default WindowUtils;
//# sourceMappingURL=WindowUtils.js.map